import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const MentalHealthContext = React.createContext();

export const useMentalHealthContext = () => useContext(MentalHealthContext);

export function MentalHealthProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/99757cef-d824-4478-abba-adc559c60fdf').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/b8bba05b-5198-40e7-a8a8-28e13104d6e9')
      .then(setSubcategories);
    fetchData.get('https://run.mocky.io/v3/aa16c95b-16ce-4f85-95d7-26b239a588c8').then(setArticles);
    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      subcategories,
      articles,
      videos,
    }),
    [banner, subcategories, articles, videos]
  );

  return <MentalHealthContext.Provider value={value}>{children}</MentalHealthContext.Provider>;
}
